export default __webpack_public_path__ + "static/media/practices.0bfbd70e.svg";